import { css } from '@emotion/react';

const payStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    infoWrapper: css({
        gap: '20px',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '20px',
    }),
    description: css({
        fontSize: '13px',
        lineHeight: '16px',
        margin: 0,
        marginBottom: '20px',
        fontWeight: 400,
    }),
    info: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    }),
    infoBlock: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '15px',
        lineHeight: '20px',
        color: '#000000',
        fontWeight: 400,
    }),
    infoBlockTitle: css({
        fontSize: '15px',
        lineHeight: '20px',
        color: '#000000',
    }),
    infoBlockValue: css({
        fontSize: '15px',
        lineHeight: '20px',
        color: '#000000',
    }),
    connectorId: css({
        textTransform: 'uppercase',
    }),
    infoBlockValueSymbol: css({
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '18px',
        color: '#101010',
        paddingLeft: '5px',
        marginRight: 5,
    }),
    infoBlockDescription: css({
        color: '#000000',
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '20px',
    }),
    actionWrapper: css({
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '22px',
    }),
    termsLink: css({
        textDecoration: 'underline',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '16px',
        color: '#004FC6',
    }),
    modalContainer: css({
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '50px',
        outline: 'none',
        overflowY: 'auto',

        '@media (min-width: 600px)': {
            justifyContent: 'center',
            maxWidth: '375px',
        },
    }),
    modalContentBlock: css({
        padding: '20px 16px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        minHeight: 'calc(100vh - 100px)',
        backgroundColor: '#ffffff',
        '@media (min-width: 600px)': {
            borderRadius: '8px',
            minHeight: 'unset',
        },
    }),
    spinnerContainer: css({
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    }),
    modalContentBlockFooter: css({
        '@media (min-width: 600px)': {
            display: 'none',
        },
    }),
};

export default payStyles;
